var _ellipse, _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDiseases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.7693,
    cy: 80.7693,
    rx: 80.7693,
    ry: 80.7693,
    fill: "#00AF91"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 162,
    height: 162
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.7693,
    cy: 80.9395,
    rx: 80.7693,
    ry: 80.7693,
    fill: "#00AF91"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.0819 78.1753C72.0819 85.06 66.5085 90.6333 59.6238 90.6333C52.7391 90.6333 47.1658 85.06 47.1658 78.1753C47.1658 71.2906 52.7391 65.7173 59.6238 65.7173C66.5085 65.7173 72.0819 71.2906 72.0819 78.1753Z",
    fill: "#000543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.433 100.141H187.4H147.158H139.126C137.568 100.141 135.847 101.37 135.273 102.927L120.029 141.777C119.455 143.334 120.193 144.563 121.75 144.563H129.782H170.025H178.057C179.614 144.563 181.335 143.334 181.909 141.777L197.154 102.927C197.728 101.37 196.99 100.141 195.433 100.141Z",
    fill: "#000543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.221 131.122C171.418 121.86 167.894 133.909 164.452 144.564C164.452 144.482 162.648 149.727 162.648 149.809C162.321 150.711 161.993 151.612 161.665 152.514L161.419 153.251L161.665 152.514C156.665 166.283 149.617 181.036 141.093 195.215L156.993 205.706C162.976 189.97 170.189 168.906 179.286 139.318C180.352 136.449 179.942 133.417 178.221 131.122Z",
    fill: "#EF9F90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.325 123.172C102.981 110.058 88.228 103.419 75.2782 109.238C64.2135 114.238 62.0005 122.844 65.8527 134.318C71.6719 151.612 81.0154 171.283 92.8997 189.396L125.52 173.742C120.602 161.447 114.619 145.137 107.325 123.172Z",
    fill: "#D2E0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7563 197.182C45.8544 179.479 39.6253 151.694 40.8548 133.499C41.5924 123.09 29.6261 123.664 35.6912 115.14C41.6744 106.616 66.3446 89.4039 76.7536 90.8792C89.8673 92.7643 98.6371 105.304 104.538 117.189C124.865 158.333 107.161 188.249 132.979 251.031C139.618 267.095 134.208 289.552 121.012 301.027C111.669 309.141 97.3258 311.682 84.9497 312.009C25.3642 313.485 14.2995 295.044 12.1685 272.258C9.46377 243.08 35.8551 222.508 41.7563 197.182Z",
    fill: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.13 100.223C85.3594 105.14 88.8837 120.467 83.4743 120.467C78.0649 120.467 64.6233 104.075 64.6233 100.223C64.6233 96.3706 68.9672 93.1741 74.3766 93.1741C79.786 93.1741 83.2284 96.4526 84.13 100.223Z",
    fill: "#EF9F90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6232 78.0933C83.3387 78.0933 94.4573 65.7638 94.4573 50.5545C94.4573 35.3452 83.3387 23.0157 69.6232 23.0157C55.9077 23.0157 44.7891 35.3452 44.7891 50.5545C44.7891 65.7638 55.9077 78.0933 69.6232 78.0933Z",
    fill: "#000543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6715 82.1914C82.4092 81.6177 83.3927 81.3718 84.2942 81.0439C88.8021 79.3228 91.179 74.3231 92.1625 69.6514C94.1295 59.98 91.7527 49.489 85.9335 41.5388C82.4911 36.8671 77.2456 32.851 71.5084 33.1788C64.6237 33.5886 59.4601 40.2275 58.3127 46.9482C57.1652 53.8329 59.0503 60.7177 60.9354 67.2745C62.6566 73.3396 66.099 95.9608 71.5084 100.059C82.819 108.501 77.8193 85.3059 81.6715 82.1914Z",
    fill: "#EF9F90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9514 62.3569C63.5581 60.5537 61.3452 59.4882 59.1322 59.7341C56.9193 59.98 54.8703 61.9471 54.7883 64.16C54.7063 66.1271 55.9358 67.9302 57.1652 69.4875C59.2961 72.2741 61.673 75.2247 65.0334 76.0443C65.3612 76.1263 65.6891 76.2083 66.0169 76.0443C66.3448 75.8804 66.5907 75.5526 66.7546 75.2247C68.6397 71.6184 66.7546 67.1926 64.8695 63.5863L64.9514 62.3569Z",
    fill: "#EF9F90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.065 32.1133C78.3929 48.3416 67.738 64.242 52.5752 70.1431C49.3788 61.4553 49.6247 50.4725 54.4603 42.5223C59.2141 34.6541 69.0494 30.2282 78.065 32.1133Z",
    fill: "#000543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1168 57.6031C44.6251 57.6031 44.1333 57.3572 43.8054 56.9474C43.2317 56.2098 43.3956 55.2263 44.1333 54.7345C45.5266 53.669 77.6553 29.2447 91.5886 35.0639C92.4082 35.3918 92.818 36.3753 92.4082 37.1949C92.0804 38.0145 91.0968 38.4243 90.2772 38.0145C80.1141 33.6706 54.8702 50.4725 46.0184 57.2753C45.7725 57.5212 45.4447 57.6031 45.1168 57.6031Z",
    fill: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1789 36.5392L92.4903 36.1294C92.4903 27.1957 96.0146 2.68941 60.0338 19.9831C32.1671 33.4247 59.2961 36.4573 60.8534 44.8173C69.5412 39.3259 80.8518 37.2769 91.1789 36.5392Z",
    fill: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.439 142.514C120.685 139.974 120.766 137.597 120.603 136.777C120.521 136.449 120.439 136.04 120.111 135.958C119.865 135.876 119.537 135.958 119.291 136.204C118.554 136.777 118.226 137.679 117.898 138.58C117.652 139.318 116.423 143.334 116.177 146.367C116.177 146.449 116.095 146.449 116.095 146.531C93.4735 166.775 67.9837 181.692 41.1825 193.494C36.1829 195.707 30.1178 197.756 23.479 199.641L37.5763 228.082C54.5421 218.984 71.9178 206.362 135.601 145.957C137.896 143.744 139.29 140.711 139.208 137.597C138.88 124.975 129.208 134.318 120.439 142.514Z",
    fill: "#EF9F90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0174 110.386C44.8707 105.55 40.1989 107.271 34.2977 117.844C27.1672 130.712 18.1515 147.186 10.0374 166.447L47.4934 180.134C52.657 170.053 59.1319 158.005 67.246 143.498C74.0487 131.45 69.0491 116.041 56.0174 110.386Z",
    fill: "#E3ECFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 209,
    height: 723.796,
    fill: "white",
    transform: "translate(-11.6821 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDiseases);
export default __webpack_public_path__ + "static/media/noDiseases.c1845fc62a80ef700f1d3bae1679ce4d.svg";
export { ForwardRef as ReactComponent };